<mat-icon
  class="contract-data-icon"
  svgIcon="contract_data"
  [matTooltip]="tooltipMessage()"
  matTooltipPosition="above"
/>
